import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=3e17e4f0&"
import script from "./MessagePage.vue?vue&type=script&lang=js&"
export * from "./MessagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports